import styled from '@emotion/styled'
import { Link, MaterialSymbols, straitsXTheme } from '@xfers/design-system'
import React from 'react'
import { useDispatch } from 'react-redux'
import { PATHS } from '~/routes/paths'
import { resetDeposit } from '~/store/deposit/actions'
import { redirect } from '~/store/route/actions'
import { resetWithdraw } from '~/store/withdraw/actions'

export default function StraitsXBreadcrumbReturnToHome() {
  const dispatch = useDispatch()
  const onClick = () => {
    resetDeposit()
    resetWithdraw()
    dispatch(redirect(PATHS.LANDING_PAGE))
  }

  return (
    <BreadcrumbLink onClick={onClick}>
      <MaterialSymbols icon="arrow_back" color={straitsXTheme.brand.primary.link} /> Return to Home
    </BreadcrumbLink>
  )
}

// TODO(jewel-chin): use new variant of Link when design system is updated
// TODO(jewel-chin): use straitsXTheme.color.base.link when base theme colors are updated

const BreadcrumbLink = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  text-decoration: none !important;
`
